"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCluster = exports.getClusterUrl = exports.CLUSTERS = exports.DEFAULT_CLUSTER = exports.Clusters = void 0;
const web3_js_1 = require("@solana/web3.js");
var Clusters;
(function (Clusters) {
    Clusters["Mainnet"] = "mainnet-beta";
    Clusters["Testnet"] = "testnet";
    Clusters["Devnet"] = "devnet";
    Clusters["Localnet"] = "localnet";
})(Clusters = exports.Clusters || (exports.Clusters = {}));
;
exports.DEFAULT_CLUSTER = {
    name: Clusters.Devnet,
    url: (0, web3_js_1.clusterApiUrl)("devnet"),
};
exports.CLUSTERS = [
    {
        name: Clusters.Mainnet,
        url: "https://api.metaplex.solana.com/",
    },
    {
        name: Clusters.Testnet,
        url: (0, web3_js_1.clusterApiUrl)("testnet"),
    },
    exports.DEFAULT_CLUSTER,
    {
        name: Clusters.Localnet,
        url: "http://127.0.0.1:8899",
    },
];
function getClusterUrl(name) {
    return getCluster(name);
}
exports.getClusterUrl = getClusterUrl;
;
function getCluster(name) {
    for (const cluster of exports.CLUSTERS) {
        if (cluster.name === name) {
            return cluster.url;
        }
    }
    return exports.DEFAULT_CLUSTER.url;
}
exports.getCluster = getCluster;
//# sourceMappingURL=index.js.map